<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员中心</el-breadcrumb-item>
      <el-breadcrumb-item>充值列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="align-items: flex-start;display: flex;justify-content: flex-start;justify-items: center;">
      <el-input size="mini" placeholder="请输入姓名或手机号进行搜索"
                v-model="orderRequest.queryOrderText"
                style="width: 200px;padding-bottom: 5px;margin-right: 5px;"
                @change="rechargeQueryText"
      ></el-input>
      <el-date-picker
        v-model="orderRequest.selectDate"
        type="daterange"
        range-separator="至"
        size="mini"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="selectKpiData"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <el-select value filterable v-model="selectAreaId" v-if="orgLevel == 1" placeholder="请选择区域" clearable
                 style="margin-left: 5px;width: 200px" size="mini" @change="getArea">
        <el-option
          v-for="item in area"
          :key="item.id"
          :label="item.orgName"
          :value="item.id">
        </el-option>
      </el-select>
      <el-select v-model="selectOrgId" clearable value filterable placeholder="请选择门店"
                 style="margin-left: 5px;width: 200px" size="mini" @change="getShop"
                v-if="orgLevel < 3"
      >
        <el-option
          v-for="org in shop"
          :key="org.id"
          :label="org.orgName"
          :value="org.id">
        </el-option>
      </el-select>
      <el-button size="mini" @click="queryRecharge">查询</el-button>
    </div>
    <span style="color: #3a8ee6; font-size: x-small">充值合计：{{czhj}}元</span>
    <el-table height="510px" :data="rechargeList" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
              :cell-style="orderStateColor"
              :row-style="{height: '0'}">
      <el-table-column
        label="操作"
        fixed="fixed"
        align="center"
        width="100">
        <template slot-scope="scope" >
          <div style="display: flex;justify-content: space-evenly">
            <el-link type="primary" icon="iconfont icon-bianji"
                     v-if="authorities.includes('customer.recharges.update')"
                     @click="showRechargeDialog(scope.row)"></el-link>
            <el-link type="danger" v-if="authorities.includes('customer.recharges.cancel')"
                     :disabled="scope.row.state === 2 || scope.row.isRefund === 1"
                     icon="iconfont icon-zuofei" @click="cancelRecharge(scope.row)"></el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="customerName"
        fixed="fixed"
        label="姓名"
        align="center">
      </el-table-column>
      <el-table-column
        prop="phone"
        fixed="fixed"
        label="手机"
        align="center" width="150">
      </el-table-column>
      <el-table-column
        align="center"
        prop="rechargeDate"
        label="充值日期" width="150">
      </el-table-column>
      <el-table-column
        align="center"
        prop="state"
        :formatter="rechargeStateFormatter"
        label="状态" >
      </el-table-column>
      <el-table-column
        align="center"
        prop="money"
        label="充值金额">
      </el-table-column>
      <el-table-column
        align="center"
        prop="payType"
        label="支付方式">
      </el-table-column>
      <el-table-column
        align="center"
        prop="orgName"
        label="充值门店" width="150">
      </el-table-column>
      <el-table-column
        align="center"
        prop="createTime"
        label="创建日期" width="150">
      </el-table-column>
<!--      <el-table-column-->
<!--        align="center"-->
<!--        prop="createName"-->
<!--        label="创建人" width="150">-->
<!--      </el-table-column>-->
      <el-table-column
        align="center"
        label="备注说明"
        width="250">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>{{ scope.row.comment }}</p>
            <div slot="reference" class="name-wrapper">
              <el-tag size="mini">{{ scope.row.comment }}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 3px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>

    <!-- 修改充值窗口-->
    <el-dialog
      title="会员卡充值"
      :visible.sync="rechargeDialogVisible"
      width="70%"
      @close="closeRechargeDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div style="margin-top:20px;width: 100%"  v-if="authorities.includes('recharges.recharge.update.yizhi')">
        <el-date-picker
          v-model="value1"
          type="date"
          size="mini"
          placeholder="订单日期"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <el-card>
        <div style="display: flex;justify-content: space-between;width: 100%;align-items: center;">
          <div style="width: 30%">
            <span style="width: 10%">充值金额：</span>
            <el-input v-model="recharge.money" readonly placeholder="请输入充值金额" size="mini" style="width: 60%;"></el-input>
          </div>
          <div style="width: 30%">
            <span style="width: 10%">赠送金额：</span>
            <el-input v-model="recharge.giveMoney" placeholder="请输入充值金额" size="mini" style="width: 60%"
                      readonly onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
          </div>
        </div>
      </el-card>
      <el-card>
        <div v-if="rechargeCustomerCard !== ''">
          <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%;">
            <div style="width: 50%">
              <span style="width: 20%">卡别名称：</span>
              <el-input v-model="rechargeCustomerCard.cardTypeName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">所属门店：</span>
              <el-input v-model="rechargeCustomerCard.shopName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%; margin-top: 10px;">
            <div style="width: 50%">
              <span style="width: 20%">会员等级：</span>
              <el-input v-model="rechargeCustomerCard.cardLevelName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">适用项目：</span>
              <el-input v-model="rechargeCustomerCard.useTypeName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-between; width: 100%; margin-top: 10px;">
            <div style="width: 50%">
              <span style="width: 20%">账户余额：</span>
              <el-input v-model="rechargeCustomerCard.balance" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">卡有效期：</span>
              <el-input v-model="rechargeCustomerCard.validDate" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div>
            <div style="width: 50%;margin-top: 10px;" >
              <span style="width: 20%">赠送金额：</span>
              <el-input v-model="rechargeCustomerCard.giveBalance" readonly size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
        </div>
      </el-card>
      <div style="margin-top:10px;display: flex;justify-content: space-between;align-items: flex-end">
        <span>服务人员：</span>
        <el-button size="mini" plain @click="showServerDialog">添加服务人员</el-button>
      </div>
      <el-card>
        <el-table :data="selectServerList" fit border stripe="stripe" width="100%" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  :row-style="{height: '0'}">
          <el-table-column
            align="center"
            label="操作" width="100">
            <template slot-scope="scope">
              <el-link type="danger" icon="el-icon-delete"
                       @click="deleteServerShowList(scope.$index, selectServerList)"></el-link>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="userName"
            label="服务人员" >
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="手机">
          </el-table-column>
          <el-table-column
            align="center"
            label="提成比例">
            <template slot-scope="scope">
              <el-input v-model="scope.row.rate" size="mini"
                        onkeyup="value=value.replace(/[^\d.]/g,'')"
                        @change="setHyOrderUserRate"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <div style="margin-top: 10px">
        <span>支付方式：</span>
      </div>
      <el-card>
        <div  style="width:100%;">
          <div  v-for="(item, index) in orgPayTypeList" :key="index" style="display: inline-block; width: 25%;margin-top: 10px" >
            <span style="display: inline-block; width: 80px;text-align: right"> {{item.payCnName}}:</span>
            <el-input v-model="item.money"
                      :disabled="item.payEnName == 'huiyuan' || item.payEnName == 'zengsonghuiyuan'
                      || item.payEnName == 'douyintuangou' || item.payEnName == 'kuaishoutuangou'
                      || item.payEnName == 'meituantuangou' || item.payEnName == 'koubeituangou'
                      || item.payEnName == 'xiaochengxutuangou'"
                      placeholder="请输入内容" size="mini" style="width: 100px;margin-right: 10px;"
                      @change="changeRechargePayType" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
            <br>
          </div>
        </div>
      </el-card>
      <div style="margin-top: 10px">
        <span>备注说明：</span>
      </div>
      <el-card>
        <el-input v-model="recharge.comment"  placeholder="请输入内容" type="textarea" size="mini" style="width: 100%;" />
      </el-card>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeRechargeDialog">取 消</el-button>
        <el-button size="mini" :disabled="isClick" @click="createRecharge">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 选择服务人员 -->
    <el-drawer
      title="服务人员列表"
      size="450px"
      :visible.sync="serverDialogVisible"
      :before-close="closeServerDialog"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-table :data="serverList" fit border stripe="stripe" width="100%"  size="mini"
                :header-cell-style="{background:'#eff3f8', color:'#333'}"
                height="570px"
                @selection-change="serverSelectChange">
        <el-table-column
          align="center"
          type="selection"
          width="60">
        </el-table-column>
        <el-table-column
          align="center"
          prop="userName"
          label="服务人员姓名">
        </el-table-column>
        <el-table-column
          align="center"
          prop="phone"
          label="手机">
        </el-table-column>
      </el-table>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data(){
    return{
      value1:'',
      customerId:'',
      authorities:'',
      currentOrgId:'',
      userId:'',
      rechargeList:[],
      queryText:'',
      rechargeStateText:[
        {state:1,name:'已充值'},
        {state:2,name:'已作废'}
      ],
      currentPage: 1,
      pageSize:20,
      pageTotal:0,

      rechargeDialogVisible:false,
      recharge:{
        payType: '',
        money:'',
        level:0,
        //现金支付金额
        cashPay:'',
        //微信支付金额
        weChatPay:'',
        //支付宝支付金额
        aliPay:'',
        //银行卡支付金额
        bankPay:'',
        //拉卡拉支付金额
        lakalaPay:'',
        posPay:'',
        miniWeChatPay:'',
        scanCodePay:'',
        //会员id
        customerId:'',
        orgId:'',
        serverId:'',
        creator:'',
        currentLevel:'',
        //赠送金额
        giveMoney:'',
        main:'',
        rechargePayTypeList:[],
        modifier:'',
        activity:'',
        isActivity:'',
        activityName:'',
        accountName:'',
        servers:[],
        serverName:'',
        rechargeDate:''
      },
      selectServerList:[],
      rateTotal:0,
      orgPayTypeList:[],
      rechargeMoney:0,
      rechargeDoubleClick:false,
      serverDialogVisible:false,
      queryServerText:'',
      serverList:[],
      orderRequest:{
        selectDate:'',
        orgId: '',
        pageNum:'',
        pageSize:'',
        startDate:'',
        endDate:'',
        name:'',
        areaId:'',
        shopId:'',
        queryOrderText:''
      },
      selectOrgId:'',
      selectAreaId:'',
      area:[],
      shop:[],
      czhj:'',
      isClick:false,
      rechargeCustomerCard:'',
      currentPage2: 1,
      pageSize2:20,
      pageTotal2:0,
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      lockDate:''
    }
  },
  methods:{
    rechargeQueryText(){
      this.currentPage = 1;
    },
    selectKpiData(){
      if (this.orderRequest.selectDate === null){
        this.orderRequest.startDate = this.getCurrentMonthLast();
        this.orderRequest.endDate = this.getCurrentMonthLast();
      } else {
        this.orderRequest.startDate = this.orderRequest.selectDate[0];
        this.orderRequest.endDate = this.orderRequest.selectDate[1];
      }
      this.currentPage=1;
    },
    setHyOrderUserRate(){
      let rateTotal = 0;
      if (this.selectServerList.length > 0){
        this.selectServerList.map((item, index) => {
          if (index === this.selectServerList.length -1){
            let rate = 100 - rateTotal;
            item.rate = rate.toFixed(2)
          } else {
            item.rate = (100 / this.selectServerList.length).toFixed(2);
            rateTotal += item.rate - 0;
          }
        })
      }
    },
    showRechargeDialog(data){
      this.isClick = data.state === 2;
      this.clearRechargePayType();
      this.loadRechargeById(data.id);
      this.loadRechargeDetail(data.id);
      this.loadRechargeServers(data.id);
      if(data.cardId > 0){
        this.loadRechargeCustomerCard(data.cardId);
      }
      this.rechargeDialogVisible = true;
    },
    closeRechargeDialog(){
      this.rechargeDialogVisible = false;
    },
    async loadRechargeCustomerCard(id){
      const {data:res} = await this.$http.get(`/load/one/customerCard/${id}`);
      this.rechargeCustomerCard = res.data;
      this.getCardLevelName(this.rechargeCustomerCard);
    },
    getCardLevelName(customerCard){
      if (customerCard.cardLevel === 0){
        customerCard.cardLevelName = '普通会员';
      }
      if (customerCard.cardLevel === 1){
        customerCard.cardLevelName = '钻石会员';
      }
      if (customerCard.cardLevel === 2){
        customerCard.cardLevelName = '铂金会员';
      }
      if (customerCard.cardLevel === 3){
        customerCard.cardLevelName = '黄金会员';
      }
      if (customerCard.cardLevel === 4){
        customerCard.cardLevelName = '大众会员';
      }
    },
    queryRecharge(){
      this.loadRechargeAmount();
      this.loadRechargeCount();
      this.loadRecharges();
    },
    dataFormatter(row,column){
      let data = row[column.property];
      if(data === null){
        return null;
      }
      let dt = new Date(data);
      return dt.getFullYear() + '-' + (dt.getMonth()+1) + '-' + dt.getDate();
    },
    rechargeStateFormatter(row){
      let value = "";
      for (let i = 0; i < this.rechargeStateText.length; i++){
        let item = this.rechargeStateText[i];
        if (row.state === item.state) {
          value = item.name;
          break;
        }
      }
      return value;
    },

    async loadRechargeAmount(){
      if (this.selectAreaId !== ''){
        this.orderRequest.areaId  = this.selectAreaId;
      }
      if (this.selectOrgId !== ''){
        this.orderRequest.shopId = this.selectOrgId;
      }
      if (this.orderRequest.selectDate === null || this.orderRequest.selectDate === ''){
        this.orderRequest.startDate = this.getCurrentMonthFirst();
        this.orderRequest.endDate = this.getCurrentMonthLast();
      } else {
        this.orderRequest.startDate = this.orderRequest.selectDate[0];
        this.orderRequest.endDate = this.orderRequest.selectDate[1];
      }

      this.orderRequest.orgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`/recharge/czhj`, this.orderRequest)
      this.czhj = res.data;
    },

    async loadRechargeCount(){
      if (this.selectAreaId !== ''){
        this.orderRequest.areaId  = this.selectAreaId;
      }
      if (this.selectOrgId !== ''){
        this.orderRequest.shopId = this.selectOrgId;
      }
      if (this.orderRequest.selectDate === null || this.orderRequest.selectDate === ''){
        this.orderRequest.startDate = this.getCurrentMonthFirst();
        this.orderRequest.endDate = this.getCurrentMonthLast();
      } else {
        this.orderRequest.startDate = this.orderRequest.selectDate[0];
        this.orderRequest.endDate = this.orderRequest.selectDate[1];
      }
      this.orderRequest.orgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`/count/recharge/load`, this.orderRequest)
      this.pageTotal = res.totalPage;
    },

    async loadRecharges(){
      this.orderRequest.pageNum = this.currentPage;
      this.orderRequest.pageSize = this.pageSize;
      if (this.selectAreaId !== ''){
        this.orderRequest.areaId  = this.selectAreaId;
      }
      if (this.selectOrgId !== ''){
        this.orderRequest.shopId = this.selectOrgId;
      }
      if (this.orderRequest.selectDate === null || this.orderRequest.selectDate === ''){
        this.orderRequest.startDate = this.getCurrentMonthFirst();
        this.orderRequest.endDate = this.getCurrentMonthLast();
      } else {
        this.orderRequest.startDate = this.orderRequest.selectDate[0];
        this.orderRequest.endDate = this.orderRequest.selectDate[1];
      }
      this.orderRequest.orgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`/recharge/load`, this.orderRequest)
      if (res.code !== 200){
        return this.$message.error("获取充值列表失败！")
      }
      this.rechargeList = res.data;
    },
    orderStateColor({row,columnIndex}){
      if (row.state === 1 && columnIndex ===4){
        return 'color:#0CB618';
      } else if (row.state === 2 && columnIndex ===4){
        return 'color:#EA1B28';
      }
    },
    async cancelRecharge(row){
      const {data:res} = await this.$http.get(`/load/one/customerCard/${row.cardId}`);
      if (res.data.balance < row.money){
        return this.$message.error("该充值记录金额>卡片金额，不允许作废");
      } else {
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
        const {data:res} = await this.$http.post(`/recharge/cancel`,row);
        this.$message.warning(res.msg);
        this.rechargeList = res.data;
        await this.queryRecharge();
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadRecharges();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadRecharges();
    },
    changeCustomerLevel(value){
      this.recharge.level = value;
    },
    showServerDialog(){
      this.loadServer();
      this.serverDialogVisible = true;
    },
    async loadServer(){
      const {data:res} = await this.$http.get(`/users/valida/${2}/orgId/${this.currentOrgId}/pageNum/${this.currentPage2}/pageSize/${this.pageSize2}`)
      this.serverList = res.data.list;
      this.pageTotal2 = res.data.total;
    },
    closeServerDialog(){
      // if (this.selectServerList.length > 0){
      //   this.selectServerList.map((item) => {
      //     item.rate = (100 / this.selectServerList.length).toFixed(1);
      //     this.rateTotal += item.rate - 0;
      //   })
      // }
      this.setHyOrderUserRate();
      this.serverDialogVisible = false;
    },
    serverSelectChange(val){
      this.selectServerList = val;
    },
    deleteServerShowList(index,rows){
      rows.splice(index, 1);
      this.setHyOrderUserRate();
    },
    async loadOrgPayType(){
      const {data:res} = await this.$http.get(`/payType/orgPayType/orgId/${this.currentOrgId}`)
      this.orgPayTypeList = res.data;
    },
    checkUserRate(){
      this.rateTotal = 0;
      this.selectServerList.map((item) =>{
        this.rateTotal += item.rate - 0;
      })
      if (this.rateTotal > 100){
        return this.$message.warning("请检查服务人员提成比例,提成比例总和不能 > 100")
      }
      if (this.rateTotal < 99){
        return this.$message.warning("请检查服务人员提成比例,提成比例总和不能 < 100")
      }
    },
    changeRechargePayType(){
      let totalMoney = this.rechargeMoney;
      let money = 0;

      this.orgPayTypeList.map((item) => {
        if (item.payEnName !== 'xianjin' && item.money > 0 && item.payEnName !== 'zengsonghuiyuan'){
          if (item.money > (totalMoney - money)){
            item.money = totalMoney - money;
          }
          money += item.money - 0;
        }
      })

      this.orgPayTypeList.map((item) => {
        if (item.payEnName === 'xianjin'){
          if ((totalMoney - money) < 0){
            item.money = 0;
          } else {
            item.money = totalMoney - money;
          }
        }
      })
    },
    async createRecharge(){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      if (this.selectServerList.length === 0){
        this.$message.warning("请添加服务人员！")
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return;
      }
      this.recharge.modifier = this.userId;
      this.recharge.servers = this.selectServerList;
      this.recharge.rechargePayTypeList = this.orgPayTypeList;
      this.recharge.rechargeDate = this.value1;
      const {data:res} = await this.$http.post(`/update/recharge`,this.recharge);
      this.rechargeList = res.data;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      this.closeRechargeDialog();
      await this.queryRecharge();
    },
    async loadRechargeById(id){
      const {data:res} = await this.$http.get(`/recharge/id/${id}`);
      this.recharge = res.data;
      this.value1 = res.data.rechargeDate;
      this.rechargeMoney = this.recharge.money;
      this.recharge.activity = '';
    },
    async loadRechargeDetail(id){
      const {data:res} = await this.$http.get(`/recharge/orgPayType/id/${id}`);
      let rechargePayType = res.data;
      this.getXianjin(rechargePayType);
    },
    getXianjin(rechargePayType){
      this.orgPayTypeList.map((item) => {
        rechargePayType.map((index) => {
          if (index.payEnName === item.payEnName){
            item.money = index.money - 0;
          }
        })
      })
    },
    async loadRechargeServers(id){
      const {data:res} = await this.$http.get(`/recharge/detail/server/rechargeId/${id}`)
      this.selectServerList = res.data;
    },
    clearRechargePayType(){
      this.orgPayTypeList.map((item) => {
        item.money = '';
      })
    },
    async getArea(data){
      if (data === ''){
        this.orderRequest.areaId = '';
      }
      await this.loadShop(data);
    },
    async loadShop(areaId){
      if (areaId !== '' ){
        const {data:res} = await this.$http.get(`/orgs/area/orgId/${areaId}`);
        this.shop = res.data;
      }
      if (areaId === ''){
        this.shop = [];
        this.selectOrgId = '';
      }
    },
    getShop(data){
      this.selectOrgId = data;
      if (data === ''){
        this.orderRequest.shopId = '';
      }
    },
    async loadAreaOrgs(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.currentOrgId}`);
      if (res.code === 200){
        this.area = res.data;
      }
    },
    getCurrentMonthFirst () {
      let date = new Date()
      date.setDate(1)
      let month = parseInt(date.getMonth() + 1)
      let day = date.getDate()
      if (month < 10) month = '0' + month
      if (day < 10) day = '0' + day
      return date.getFullYear() + '-' + month + '-' + day
    },
    getCurrentMonthLast () {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      month = month < 10 ? '0' + month : month
      let day = new Date(year, month, 0)
      return year + '-' + month + '-' + day.getDate()
    },
    disabledDate(time){
      // return time.getTime() <= Date.parse('2023-07-31') - 8.64e7;
      return time.getTime() <= Date.parse(this.lockDate) - 8.64e7;
    },
    async loadLockDate(){
      const {data:res} = await this.$http.get(`/load/lock/date`)
      if(res.data != null){
        this.lockDate = res.data;
      }
    },
  },
  created() {
    this.loadLockDate();
    this.currentOrgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.orgLevel = window.sessionStorage.getItem('orgLevel');
    this.queryRecharge();
    this.loadOrgPayType();
    this.loadAreaOrgs();
    if (this.orgLevel > 1){
      this.loadShop(this.currentOrgId);
    }
  }
}
</script>

<style lang="less" scoped>
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
    text-align: center !important;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-dialog{
  background: #fafaff !important;
}
/deep/ .el-dialog__header{
  padding: 15px 20px 10px;
}
/deep/ .el-dialog__body{
  padding: 5px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.dialog-footer{
  display: flex;
  margin: 10px 10px 10px 0;
  justify-content: center;
  width: 100%;
}
/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  margin-bottom:0;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Recharges.vue